import { useGlobalAction } from "@gadgetinc/react";
import { message as antdMessage } from "antd";
import { api } from "../../../api";
import { Button } from "../../../externalComponents/tailwind/button";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../../../externalComponents/tailwind/dialog";

export default function AnonymizeContactDialog({
  open,
  onClose,
  contactId,
  hasOptedOut,
  onSuccess,
}) {
  const [{ fetching: isLoading }, anonymizeContact] = useGlobalAction(
    api.anonymizeContact,
  );

  const handleAnonymize = async () => {
    try {
      const result = await anonymizeContact({ contactId });

      if (result.error) {
        antdMessage.error("Failed to anonymize contact: " + result.error.message);
        return;
      }

      antdMessage.success("Contact anonymized");
      onSuccess?.();
      onClose();
    } catch (error) {
      antdMessage.error("Failed to anonymize contact: " + error.message);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Anonymize contact</DialogTitle>
      <DialogBody>
        <p>
          This will permanently erase this contact's personal data: names,
          social network ID, profile info, and the content and attachments of
          the messages they sent. This action cannot be undone.
        </p>
        {!hasOptedOut && (
          <p className="mt-3">
            This contact hasn't opted out yet — they will also be opted out
            as part of this action.
          </p>
        )}
      </DialogBody>
      <DialogActions>
        <Button color="secondaryButton" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <Button color="red" onClick={handleAnonymize} loading={isLoading}>
          Anonymize
        </Button>
      </DialogActions>
    </Dialog>
  );
}
